module.exports = __webpack_public_path__ + "static/media/4.MK 12 Vibrator.004ec864.jpg";